/* hs-eslint ignored failing-rules */
'use es6';

import { combineReducers } from 'redux';
import SeamlessImmutable from 'seamless-immutable';
import { PORTAL_COPY_ASSET_DEPENDENCIES_FETCH, PORTAL_COPY_REQUEST_SET_ACTIVE, FINDER_ASSETS_PORTAL_COPY_REQUEST, FINDER_ASSETS_PORTAL_COPY_RECEIVE, FINDER_ASSETS_PORTAL_COPY_ERROR, FINDER_ASSETS_PORTAL_COPY_RESET, ASSETS_PORTAL_COPY_ACCESS_FETCH, ASSETS_PORTAL_COPY_ACCESS_RESET } from 'DesignData/actions/ActionTypes';
import CopyStatus from 'DesignData/enums/CopyStatus';
/**
 * SHAPE
 *
 * {
 *   assets: {
 *      fetchPortalsForCopyInProgress: false,
 *      fetchPortalsForCopyError: Error{...},
 *      portalsById: {
 *        123: domain,
 *        124: domain,
 *      },
 *      portalCopyStatusById: {
 *        1234567890: false,
 *        5678342901: false,
 *      },
 *    },
 *   portalsById: {
 *     123: domain
 *     124: domain
 *   },
 *   activeRequestId: "portal-copy-request-1",
 *   isFetchingDependenciesByRequestId: {
 *     "portal-copy-request-1": true,
 *     "portal-copy-request-2": false,
 *   },
 *   fetchDependenciesErrorByRequestId: {
 *     "portal-copy-request-1": new Error(...),
 *   },
 *   dependenciesByRequestId: {
 *     "portal-copy-request-1": {
 *       3171708491: PortalCopyDependency
 *     },
 *     "portal-copy-request-2": {},
 *   },
 *   isEnqueuingByRequestId: {
 *     "portal-copy-request-1": true,
 *     "portal-copy-request-2": false,
 *   },
 *   enqueueResponseByRequestId: {
 *     "portal-copy-request-1": {...},
 *   },
 *   enqueueErrorByRequestId: {
 *     "portal-copy-request-1": new Error(...),
 *   }
 * }
 */

function assets(state = SeamlessImmutable({
  fetchPortalsForCopyInProgress: false,
  fetchPortalsForCopyError: {},
  portalsById: {},
  portalCopyStatusById: {},
  portalCopyErrorById: {}
}), action) {
  switch (action.type) {
    case FINDER_ASSETS_PORTAL_COPY_REQUEST:
    case FINDER_ASSETS_PORTAL_COPY_RECEIVE:
      {
        const {
          assetIds,
          copyStatus
        } = action;
        return SeamlessImmutable.merge(state, {
          portalCopyStatusById: Object.fromEntries(assetIds.map(a => [a, copyStatus])),
          portalCopyErrorById: Object.fromEntries(assetIds.map(a => [a, null]))
        }, {
          deep: true
        });
      }

    case FINDER_ASSETS_PORTAL_COPY_ERROR:
      {
        const {
          assetIds,
          copyStatus,
          error
        } = action;
        const {
          objects,
          forgotten = []
        } = error;
        return SeamlessImmutable.merge(state, {
          portalCopyStatusById: Object.fromEntries(assetIds.map(a => [a, copyStatus]).concat(forgotten.map(a => [a, CopyStatus.FAILED]))),
          portalCopyErrorById: Object.fromEntries(assetIds.map((a, i) => [a, objects[i]]))
        }, {
          deep: true
        });
      }

    case FINDER_ASSETS_PORTAL_COPY_RESET:
      {
        return SeamlessImmutable.merge(state, {
          portalCopyStatusById: {},
          portalCopyErrorById: {}
        });
      }

    case ASSETS_PORTAL_COPY_ACCESS_FETCH:
      {
        return SeamlessImmutable.merge(state, {
          fetchPortalsForCopyInProgress: !(action.portals || action.error),
          fetchPortalsForCopyError: action.error || {},
          portalsById: action.portals || {}
        });
      }

    case ASSETS_PORTAL_COPY_ACCESS_RESET:
      {
        return SeamlessImmutable.merge(state, {
          fetchPortalsForCopyInProgress: false,
          fetchPortalsForCopyError: {},
          portalsById: {}
        });
      }

    default:
      {
        return state;
      }
  }
}

function activeRequestId(state = null, action) {
  switch (action.type) {
    case PORTAL_COPY_REQUEST_SET_ACTIVE:
      {
        return action.requestId;
      }

    default:
      {
        return state;
      }
  }
}

function isFetchingDependenciesByRequestId(state = {}, action) {
  switch (action.type) {
    case PORTAL_COPY_ASSET_DEPENDENCIES_FETCH:
      {
        const {
          requestId,
          dependencies,
          error
        } = action;
        return Object.assign({}, state, {
          [requestId]: !(dependencies || error)
        });
      }

    default:
      {
        return state;
      }
  }
}

function fetchDependenciesErrorByRequestId(state = {}, action) {
  switch (action.type) {
    case PORTAL_COPY_ASSET_DEPENDENCIES_FETCH:
      {
        const {
          requestId,
          error
        } = action;
        return Object.assign({}, state, {
          [requestId]: error
        });
      }

    default:
      {
        return state;
      }
  }
}

function dependenciesByRequestId(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case PORTAL_COPY_ASSET_DEPENDENCIES_FETCH:
      {
        const {
          requestId,
          dependencies
        } = action;
        if (!dependencies) return state;
        return Object.assign({}, state, {
          [requestId]: dependencies
        });
      }

    default:
      {
        return state;
      }
  }
}

export default combineReducers({
  assets,
  activeRequestId,
  isFetchingDependenciesByRequestId,
  fetchDependenciesErrorByRequestId,
  dependenciesByRequestId
});